import { Link } from "react-router-dom";
import { Seo } from "@/site/seo";

export default function NotFound() {
  return (
    <>
      <Seo title="Page not found" noindex />
      <section className="section"><div className="wrap" style={{ textAlign: "center", padding: "80px 0" }}>
        <div className="eyebrow">404</div>
        <h1 className="h2" style={{ margin: "12px auto" }}>That door isn't here.</h1>
        <p className="lede" style={{ margin: "0 auto 24px" }}>The page may have moved. The product tour, pricing and security pages are one click away.</p>
        <Link to="/" className="btn btn--primary">Back to the front door</Link>
      </div></section>
    </>
  );
}
